import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { TagContext } from '../../Tag.context';
import { Icon } from '../../../Icon/Icon';
import { useColor } from './hooks';
import { useClassName } from '../../../../hooks';
import './CloseButton.scss';
export const CloseButton = () => {
    const color = useColor();
    const { onDelete } = useContext(TagContext);
    const className = useClassName({ name: 'tag-close-button', prefixed: true }, 'cursor-pointer');
    if (onDelete == null)
        return null;
    return (_jsx("div", { "data-testid": 'tag-component-close-button', className: className, onClick: onDelete, children: _jsx(Icon, { name: 'multiply', color: color, size: 'md' }) }));
};
